import React from 'react';
import {  Row, Col, Image } from 'react-bootstrap';

import styles from './styles.module.scss';
import cx from 'classnames'

const SuperHeroImage = '/images/superhero.png'
const UnsubscribeSuccessSvgIcon = '/images/homeEmptyMessage.svg'
const UnsubscribeImage = '/images/signin.gif';



class UnsubscribeView extends React.Component {

  constructor(props){
      super(props);

      this._handleCancelClick = this._handleCancelClick.bind(this);
      this._handleUnsubscribeClick = this._handleUnsubscribeClick.bind(this); 
      this._handleSubscribeClick = this._handleSubscribeClick.bind(this); 

      this.state = {
        showUnsubscribeConfirmation: true
      }
    }

    _handleCancelClick(){
      window.close();
    }

    _handleUnsubscribeClick(){
      var contactKey = this.props.location.query.key;
      var contactId = this.props.params.contactId;
      var conversationId = this.props.location.query.conversation;

      this.props.unsubscribeContact(contactId, conversationId, contactKey).then(() => {
        if (!this.props.subscribed) {
          this.setState({
            showUnsubscribeConfirmation: false
          })
        }
      });
    }

    _handleSubscribeClick(){
      var contactKey = this.props.location.query.key;
      var contactId = this.props.params.contactId;
      var conversationId = this.props.location.query.conversation;
      
      this.props.resubscribeContact(contactId, conversationId, contactKey);
    }

    componentDidMount(){
    }

    render() {
      return (
        <div className={styles.content}>  
          <div className={styles.background}>&nbsp;</div>
          <div className={cx(styles.innerContent, styles.verticalCenter, styles.unsubscribeBox)}>
            { this.state.showUnsubscribeConfirmation && this.props.subscribed &&
              <div className = {styles.unsubscribeContainer}> 
                <div className={styles.slide}>
                  <div className = {styles.heading} >Don't want to fly anymore? </div>
                  <Row>
                    <Col sm={12}>
                      <Image src={UnsubscribeImage} />
                    </Col>
                    <Col sm={6} className = {styles.description}>
                      <span >
                        Did you click the forbidden <br/> button by mistake?
                      </span>
                      <div> 
                        <button className = {styles.action} disabled = {this.props.updating} onClick = {this._handleCancelClick}>[Cancel]</button>
                      </div>    
                    </Col>
                    <Col sm={6} className = {cx(styles.description, styles.unsubscribeAction)}>
                      <span >
                        Got other priorities? it's ok, go ahead, <br/> click [unsubscribe] anyways. 
                      </span> 
                      <div>
                        <button className = {styles.action} 
                          disabled = {this.props.updating} 
                          onClick = {this._handleUnsubscribeClick}>
                           {this.props.updating ? '[Unsubscribing...]' : '[Unsubscribe]' }
                        </button>  
                      </div>
                    </Col>
                  </Row>
                </div>  
              </div>
            }
            {!this.props.subscribed &&  
              <div className = {styles.unsubscribeSuccessContainer}>
                <div className={styles.slide}>
                    <div className = {styles.heading} >Unsubscribe successful </div>
                    <p className={styles.paragraph}>It can get lonely and cold out there. When you want to fly again, remember,
                    we'd love to have you back with open arms any day!</p>
                    <Row>
                      <Col sm={12}>
                        <Image src={UnsubscribeSuccessSvgIcon} />
                      </Col>
                      <Col sm={12} className = {styles.padding}>
                        <span className = {styles.bottomText}>
                          Did you just change your mind?
                        </span>

                        <div><button className = {styles.action} disabled = {this.props.updating} onClick = {this._handleSubscribeClick}>[Subscribe]</button></div>  
                      </Col>
                    </Row>
                </div>
              </div>
            }
            {!this.state.showUnsubscribeConfirmation && this.props.subscribed &&  
              <div className = {styles.unsubscribeSuccessContainer}>
                <div className={styles.slide}>
                  <div className = {styles.heading} >Thank you! </div>
                  <div className = {styles.subscribeText}>Wait! Super hero landing coming up! </div>
                  <Row>
                    <Col sm={12}>
                      <Image src={SuperHeroImage} />
                    </Col>
                    <Col sm={12} className = {styles.padding}>
                      <span className = {styles.bottomText}>
                        We are glad to have you back!
                      </span>
                    </Col>
                  </Row>
                </div>
              </div>
            }
          </div>
        </div>  
      );
    }  
}
export default UnsubscribeView;